import type { TimerAlertSettings } from "./useRecipeTimers";

export function playTimerAlert(settings: TimerAlertSettings): void {
  if (settings.vibration && typeof navigator.vibrate === "function") {
    navigator.vibrate([200, 100, 200]);
  }
  if (settings.sound) {
    playBeep();
  }
}

function playBeep(): void {
  if (typeof window.AudioContext !== "function") {
    return;
  }
  const context = new window.AudioContext();
  const oscillator = context.createOscillator();
  const gain = context.createGain();
  oscillator.type = "sine";
  oscillator.frequency.value = 880;
  gain.gain.value = 0.08;
  oscillator.connect(gain);
  gain.connect(context.destination);
  oscillator.start();
  oscillator.stop(context.currentTime + 0.15);
  oscillator.onended = () => {
    void context.close();
  };
}

export function saveTimerAlertSettings(settings: TimerAlertSettings): void {
  localStorage.setItem("cairn.timerAlerts", JSON.stringify(settings));
}
